export default __webpack_public_path__ + "static/media/tower_gal.6eda82ca.jpg";